import { Button } from "@/components/ui/button";
import { toast } from "@/components/ui/sonner";
import { useT } from "@/i18n";

function startGoogle() {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + "/app";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

function GoogleIcon() {
  return (
    <svg viewBox="0 0 24 24" className="h-4 w-4" aria-hidden="true">
      <path fill="#EA4335" d="M12 10.2v3.9h5.5c-.2 1.4-1.6 4.1-5.5 4.1-3.3 0-6-2.7-6-6.1s2.7-6.1 6-6.1c1.9 0 3.1.8 3.9 1.5l2.6-2.5C17.1 2.9 14.8 2 12 2 6.9 2 2.8 6.1 2.8 11.9S6.9 21.9 12 21.9c6.9 0 9.2-4.8 9.2-7.3 0-.5 0-.8-.1-1.2H12z"/>
    </svg>
  );
}

export function SocialButtons() {
  const t = useT();
  return (
    <div className="space-y-3">
      <Button
        type="button"
        variant="outline"
        className="w-full rounded-full"
        onClick={startGoogle}
        data-testid="google-auth-btn"
      >
        <GoogleIcon /> {t("auth.google")}
      </Button>
      <Button
        type="button"
        variant="outline"
        className="w-full rounded-full opacity-70"
        onClick={() => toast(t("auth.apple_toast"))}
        data-testid="apple-auth-btn"
      >
        <svg viewBox="0 0 24 24" className="h-4 w-4" fill="currentColor" aria-hidden="true">
          <path d="M16.37 1.43c.06 1-.33 1.98-.98 2.7-.68.76-1.78 1.34-2.84 1.26-.1-1 .38-2.02 1-2.68.68-.74 1.86-1.3 2.82-1.28zM20.4 17.3c-.52 1.2-.77 1.74-1.44 2.8-.94 1.47-2.26 3.3-3.9 3.32-1.46.02-1.84-.95-3.82-.94-1.98 0-2.4.96-3.86.95-1.64-.02-2.9-1.67-3.84-3.14C1.1 17.1.82 11.9 2.4 9.14c1.06-1.83 2.75-2.9 4.35-2.9 1.6 0 2.6 1.04 3.92 1.04 1.28 0 2.06-1.04 3.9-1.04 1.46 0 3 .8 4.1 2.17-3.6 1.98-3 7.1.73 8.9z"/>
        </svg>
        {t("auth.apple")}
      </Button>
    </div>
  );
}
